import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
import { secondsToDisplay } from "@/utils/util";
import { computed } from "vue";
import { INTERVAL } from "@/utils/const";
import { useOverviewThresholdSettingStore } from "@/store/pinia/useOverviewThresholdSettingStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MainTimeTableCell',
    props: {
        node: {},
        intervalId: {},
        field: {},
        headerLabelsBeforeToday: {},
        selectedInterval: {}
    },
    setup(__props) {
        const props = __props;
        const timeInterval = computed(() => {
            return props.node.timeIntervalValues.find((timeInterval) => timeInterval.id === props.intervalId);
        });
        const isWorkingDay = computed(() => {
            if (props.selectedInterval === INTERVAL.WEEKLY)
                return true;
            return (timeInterval.value?.dayType === "WORKDAY" ||
                timeInterval.value?.dayType === "EXTRA_WORKDAY");
        });
        const isWeekendOrHoliday = computed(() => {
            return !isWorkingDay.value && (timeInterval.value?.[props.field] ?? 0) === 0;
        });
        const getTimeValue = () => {
            if (!timeInterval.value)
                return { label: "0:00", isRootTimeOffAndSecondsAreZero: false };
            const seconds = timeInterval.value[props.field];
            const isRootTimeOffAndSecondsAreZero = props.field === "timeOff" && seconds === null;
            return {
                label: secondsToDisplay(seconds),
                isRootTimeOffAndSecondsAreZero,
            };
        };
        const overallThresholdInSeconds = computed(() => {
            return overallThreshold.value * 3600;
        });
        const timeOff = computed(() => {
            return timeInterval.value?.timeOff ?? 0;
        });
        const workScheduleTime = computed(() => {
            return timeInterval.value?.workScheduleTime ?? 0;
        });
        const loggedTime = computed(() => {
            return timeInterval.value?.loggedTime ?? 0;
        });
        const getClasses = () => {
            const weekendOrHolidayColor = "!bg-surface-50 dark:!bg-surface-0 !border-surface-100";
            const primarySuccessColor = "!bg-emerald-50 dark:!bg-emerald-950 !border-surface-100 !text-emerald-500";
            const warningColor = "bg-orange-50 dark:bg-orange-950 border-surface-100 !text-orange-500";
            const dangerColor = "bg-red-50 dark:bg-red-950 border-surface-100 !text-red-500";
            // If not a working day and the field value is 0, return the weekend or holiday color
            if (isWeekendOrHoliday.value)
                return weekendOrHolidayColor;
            // If the date is in the future, and there is logged time, colorize as danger
            if (!colorizeEnabled() &&
                props.field === "loggedTime" &&
                loggedTime.value > 0 + overallThresholdInSeconds.value)
                return dangerColor;
            // Turn off colorization filds in the future
            if (!colorizeEnabled() && props.field !== "timeOff")
                return "";
            switch (props.field) {
                case "loggedTime":
                    if (timeOff.value > workScheduleTime.value && loggedTime.value === 0)
                        return primarySuccessColor;
                    else if (loggedTime.value <=
                        workScheduleTime.value -
                            timeOff.value +
                            overallThresholdInSeconds.value &&
                        loggedTime.value >=
                            workScheduleTime.value -
                                timeOff.value -
                                overallThresholdInSeconds.value) {
                        return primarySuccessColor;
                    }
                    else if (loggedTime.value !== workScheduleTime.value)
                        return dangerColor;
                    else
                        return "";
                case "timeOff":
                    if (timeOff.value !== 0 && timeOff.value !== null)
                        return warningColor;
                    else
                        return "";
                case "workScheduleTime":
                default:
                    return "";
            }
        };
        const colorizeEnabled = () => {
            const headerLabelsBeforeToday = props.headerLabelsBeforeToday;
            const timeInterval = props.node.timeIntervalValues.find((timeInterval) => timeInterval.id === props.intervalId);
            if (!timeInterval)
                return false;
            return headerLabelsBeforeToday?.includes(timeInterval.id);
        };
        // Threshold settings
        const overviewThresholdSettingStore = useOverviewThresholdSettingStore();
        const overallThreshold = computed(() => {
            return overviewThresholdSettingStore.overallLoggedTimeComplianceErrorThreshold;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["min-w-[100px] h-[28.5px] flex items-center justify-center border-surface-100 text-surface-950 text-sm font-normal border-r border-b", ['font-semibold', getClasses()]])
            }, [
                (__props.field === 'timeOff' && getTimeValue().isRootTimeOffAndSecondsAreZero)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
                    : (!isWeekendOrHoliday.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(getTimeValue().label), 1))
                        : _createCommentVNode("", true)
            ], 2));
        };
    }
});
